import React from 'react';
import styled from 'styled-components';

import Icon from './Icon';
import facebook from './facebook.svg';
import instagram from './instagram.svg';
import twitter from './twitter.svg';

const StyledFooter = styled.footer`
  background: #545554;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
`;

const StyledContainer = styled.footer`
  width: 800px;
  color: white;
  display: flex;
  font-size: 0.8rem;
  padding: 0 10px;
  justify-content: space-between;
  ul {
    list-style: none;
    padding-inline-start: 0;
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    li {
      display: inline;
      padding: 0 10px;
      &:last-child {
        padding-right: 0;
      }
      svg {
        height: 20px;
        width: 20px;
        filter: contrast(0%);
        transition: filter 0.2s;
        transition-timing-function: cubic-bezier(0.39, 0.575, 0.565, 1);
        &:hover {
          filter: contrast(100%);
        }
      }
    }
  }
`;

class Footer extends React.Component {
  render() {
    const date = new Date();
    return (
      <StyledFooter>
        <StyledContainer>
          <p>Copyright &copy; {date.getFullYear()} Health Farm</p>
          <ul>
            <li>
              <a 
                aria-label="Visit Health Farm's Facebook"
                title="Facebook" 
                href="https://www.facebook.com/HealthfarmHQ"
                target="_blank"
                rel="noopener"
              >
                <Icon icon={facebook} />
              </a>
            </li>
            <li>
                <a
                  aria-label="Visit Health Farm's Instagram"
                  title="Instagram" 
                  href="https://www.instagram.com/healthfarmhq"
                  target="_blank"
                  rel="noopener"
                >
                  <Icon icon={instagram} />
                </a>
              </li>
            <li>
              <a 
                aria-label="Visit Health Farm's Twitter"
                href="https://twitter.com/healthfarmhq"
                target="_blank"
                rel="noopener"
              >
                <Icon icon={twitter} />
              </a>
            </li>
          </ul>
        </StyledContainer>
      </StyledFooter>
    )
  }
}

export default Footer
